import { Component, input } from '@angular/core';
import {FilterCheckbox, MeldungBewilligungFilter, MeldungBewilligungFilterType} from '@app/shared/classes/meldung-bewilligung-filter';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'meldung-list-filter',
  templateUrl: './meldung-list-filter.component.html',
  imports: [
    TranslatePipe,
  ]
})
export class MeldungListFilterComponent {

  readonly filter = input.required<MeldungBewilligungFilter>();

  readonly ICON_CLASSES = {
    [FilterCheckbox.DEFAULT] : 'cursor-pointer glyphicon glyphicon-unchecked     gray',
    [FilterCheckbox.INCLUDE] : 'cursor-pointer glyphicon glyphicon-ok-circle     green',
    [FilterCheckbox.EXCLUDE] : 'cursor-pointer glyphicon glyphicon-remove-circle red'
  };

  getIcon(property: keyof MeldungBewilligungFilterType): string {
    let value = this.filter()[property];
    return this.ICON_CLASSES[value] ?? this.ICON_CLASSES[FilterCheckbox.DEFAULT];
  }

  toggleIcon(property: keyof MeldungBewilligungFilterType): void {
    switch (this.filter()[property]) {
      case FilterCheckbox.INCLUDE: this.filter()[property] = FilterCheckbox.EXCLUDE; break
      case FilterCheckbox.EXCLUDE: this.filter()[property] = FilterCheckbox.DEFAULT; break
      default:                     this.filter()[property] = FilterCheckbox.INCLUDE; break
    }
  }
}
